import React from 'react';
import {
  VideoCameraOutlined, PictureOutlined, AudioOutlined, CustomerServiceOutlined,
  FilePdfOutlined, FundProjectionScreenOutlined, TableOutlined, AppstoreOutlined,
  DashboardOutlined, CodeOutlined, BoxPlotOutlined, SearchOutlined,
} from '@ant-design/icons';
import useReveal from '../../AIEmployees/useReveal';
import './SAModalities.css';

/**
 * SAModalities — the breadth grid. Every output a super-agent can produce from
 * natural language, reinforcing "every modality" with concrete artifacts.
 */
const ITEMS = [
  { Icon: VideoCameraOutlined, label: 'Video' },
  { Icon: PictureOutlined, label: 'Images' },
  { Icon: AudioOutlined, label: 'Speech' },
  { Icon: CustomerServiceOutlined, label: 'Music' },
  { Icon: FilePdfOutlined, label: 'PDFs' },
  { Icon: FundProjectionScreenOutlined, label: 'Presentations' },
  { Icon: TableOutlined, label: 'Spreadsheets' },
  { Icon: AppstoreOutlined, label: 'Web apps' },
  { Icon: DashboardOutlined, label: 'Dashboards' },
  { Icon: CodeOutlined, label: 'Code' },
  { Icon: BoxPlotOutlined, label: '3D models' },
  { Icon: SearchOutlined, label: 'Deep research' },
];

const SAModalities = () => {
  const [ref, visible] = useReveal();
  return (
    <section className="sa-mod aie-section">
      <div className="aie-section-head">
        <h2 className="aie-section-title aie-display">One prompt. Any output.</h2>
        <p className="aie-section-sub">
          One agent reasons through the task, then produces the finished
          artifact, in whatever format the job calls for.
        </p>
      </div>
      <div className={`sa-mod__grid aie-reveal ${visible ? 'is-visible' : ''}`} ref={ref}>
        {ITEMS.map(({ Icon, label }) => (
          <div className="sa-mod__tile" key={label}>
            <span className="sa-mod__icon"><Icon /></span>
            <span className="sa-mod__label">{label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SAModalities;
